<template>

  <div class="v-input v-input--horizontal v-input--density-default v-input--dirty v-input--readonly v-text-field v-text-field--flush-details">

    <div class="v-input__control">
      <div class="v-field v-field--active v-field--dirty v-field--variant-plain v-theme--ocra" role="textbox">

        <!--
        <div class="v-field__overlay"></div>
        <div class="v-field__loader">
          <div class="v-progress-linear v-theme--ocra" role="progressbar" aria-hidden="true" aria-valuemin="0" aria-valuemax="100" style="top: 0px; height: 0px; --v-progress-linear-height:2px; left: 50%; transform: translateX(-50%);">
            <div class="v-progress-linear__background" style="width: 100%;"></div>
            <div class="v-progress-linear__indeterminate">
              <div class="v-progress-linear__indeterminate long"></div>
              <div class="v-progress-linear__indeterminate short"></div>
            </div>
          </div>
        </div>
        -->

        <div class="v-field__field">
          <!-- <label class="v-label v-field-label" for="input-338">{{ label }}</label> -->
          <!-- <input readonly="" size="1" type="text" id="input-338" aria-describedby="input-338-messages" class="v-field__input"> -->
          <div class="v-field__input">
            <slot></slot>
          </div>
        </div>
        <div class="v-field__outline">
          <label class="v-label v-field-label v-field-label--floating" aria-hidden="true" for="input-338">{{ label }}</label>
        </div>
      </div>
    </div>
    
    <!--
    <div class="v-input__details">
      <div class="v-messages" role="alert" aria-live="polite" id="input-338-messages"></div>
    </div>
    -->

  </div>  

</template>

<script setup>

/**
 * Template for wrapping complex content (e.g., text with icons) that can't be
 * placed inside a readonly <o-text-field>.
 * 
 * I basically just inspected a readonly <o-text-field> in the browser, copied
 * the HTML, and commented out unnecessary divs.
 * 
 * The variant, density, etc. are currently hardcoded, but these could be
 * added as props.
 */

const props = defineProps({

  label: {
    type: String,
    required: true,
  },

})

</script>
